<div class="banner"></div>
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 search-box">
  <div class="d-flex justify-content-center search-form form-back-panel">
      <form [formGroup]="searchForm" (ngSubmit)="search()">        
        <h1 class="citation-title text-center">Citation Search</h1>
        <mat-form-field class="form-field">
          <mat-label>Citation Number</mat-label>
          <input class="search-input" matInput placeholder="AAA0000000" formControlName="citation_number">
        </mat-form-field><br>
        <mat-form-field class="form-field">
          <mat-label>License Plate</mat-label>
          <input class="search-input" matInput placeholder="ABC 1233" formControlName="license_plate">
        </mat-form-field><br>
        <button mat-raised-button style="width: 100%" class="submit-button" type="submit">Search</button>
      </form>
    </div>
</div>